import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import RightPanel from './rightPanel';
import CenterPanel from './centerPanel';
import RightPanelConfirmation from './rightPanelConfirmation';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import {
  removeInvitedRole,
  undoRemoveInvitedRole,
  removeAllInvitedRoles,
  undoRemoveAllInvitedRoles,
} from 'actions/user';

export default function ManageInvitationsContent(props) {
  const [searchTerm, setSearchTerm] = useState('');
  const [saveIntermediateClick, setSaveIntermediateClick] = useState(false);
  const [confirmSaveClick, setConfirmSaveClick] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  let intendedDeletedInvitatioans = [];

  if (props.selectedUserInvitationForm != undefined) {
    intendedDeletedInvitatioans = props.selectedUserInvitationForm.roles.filter((invitation) => {
      return invitation.isDeleted == true;
    });
  }

  useEffect(
    // If delete all roles, then set selectAll to be true
    () => {
      if (props.selectedUserInvitationForm.roles.length == intendedDeletedInvitatioans.length) setSelectAll(true);
    },
    [intendedDeletedInvitatioans]
  );

  const handleSearchTerm = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSave = () => {
    if (intendedDeletedInvitatioans.length === 0) return;
    setSaveIntermediateClick(true);
    setSearchTerm('');
  };

  const goBackToPreviousView = () => {
    setSaveIntermediateClick(false);
    setSearchTerm('');
  };

  const selectAllClick = (event, data) => {
    if (data.checked == true) {
      // If select all means intending to delete all roles
      props.dispatch(removeAllInvitedRoles(() => setSelectAll(!selectAll)));
    } else if (data.checked == false) {
      // If select all means intending to undo delete all roles
      props.dispatch(undoRemoveAllInvitedRoles(() => setSelectAll(!selectAll)));
    }
  };

  const cancelConfirmUpdate = () => {
    setSaveIntermediateClick(false);
  };

  const handleDeleteRole = (personNetworkRoleId) => {
    if (!saveIntermediateClick) {
      props.dispatch(removeInvitedRole(personNetworkRoleId));
    }
  };

  const handleUndoDeleteRole = (personNetworkRoleId) => {
    setSelectAll(false);
    props.dispatch(undoRemoveInvitedRole(personNetworkRoleId));
  };

  return (
    <Modal show={true} hideWhenClickAway={false} className="ui modal">
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.ManageAllUsers.HelpInvitations}
        title={APP.LANGUAGE.ManageInvitations.Title}
        subtitle={props.selectedUser.email}
      />
      <div className="content mrtxxs">
        <div className="main-ui-container pdbl">
          <div id="righthandfloatingpanel" style={{ minHeight: '500px' }}>
            <div className="right ui rail mrtxs">
              <div className="ui sticky">
                {saveIntermediateClick ? (
                  <RightPanelConfirmation
                    selectedUser={props.selectedUser}
                    intendedDeletedInvitatioans={intendedDeletedInvitatioans}
                    cancelConfirmUpdate={cancelConfirmUpdate}
                    goBackToPreviousView={goBackToPreviousView}
                    selectedUserInvitationForm={props.selectedUserInvitationForm}
                    dispatch={props.dispatch}
                  />
                ) : (
                  <RightPanel
                    selectedUser={props.selectedUser}
                    intendedDeletedInvitatioans={intendedDeletedInvitatioans}
                    handleSave={handleSave}
                    dispatch={props.dispatch}
                  />
                )}
              </div>
            </div>
            <CenterPanel
              handleSearchTerm={handleSearchTerm}
              timezone={props.timezone}
              searchTerm={searchTerm}
              ifSelectAll={selectAll}
              selectAllClick={selectAllClick}
              handleDeleteRole={handleDeleteRole}
              handleUndoDeleteRole={handleUndoDeleteRole}
              saveIntermediateClick={saveIntermediateClick}
              selectedUserInvitationForm={props.selectedUserInvitationForm}
              dispatch={props.dispatch}
            />
            <div className="bottom-rail-with-left-and-right-content mrtxl pdts">
              {saveIntermediateClick ? (
                <RightPanelConfirmation
                  selectedUser={props.selectedUser}
                  intendedDeletedInvitatioans={intendedDeletedInvitatioans}
                  selectedUserInvitationForm={props.selectedUserInvitationForm}
                  cancelConfirmUpdate={cancelConfirmUpdate}
                  goBackToPreviousView={goBackToPreviousView}
                  dispatch={props.dispatch}
                />
              ) : (
                <RightPanel
                  selectedUser={props.selectedUser}
                  intendedDeletedInvitatioans={intendedDeletedInvitatioans}
                  handleSave={handleSave}
                  dispatch={props.dispatch}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
